import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useImpersonation } from '../ImpersonationContext';
import { useNotification } from '../../../context/NotificationContext';
import { getMainAppOrigin } from '../../config/adminHost';
import { buildImpersonationLandingUrl } from '../../../impersonation/utils/impersonationHandoff';
import { waitForImpersonationExitMin } from '../../../impersonation/exit/impersonationExit';

function openImpersonationLanding(url, navigate) {
  try {
    const target = new URL(url, window.location.origin);
    if (target.origin === window.location.origin) {
      navigate(`${target.pathname}${target.search}${target.hash}`, { replace: true });
      return;
    }
  } catch {
    // Fall through to a full navigation for cross-origin admin hosts.
  }
  window.location.assign(url);
}

const ImpersonateButton = ({ userId, companyId, disabled, fullWidth }) => {
  const { impersonateUser, loading, error } = useImpersonation();
  const { showToast } = useNotification();
  const navigate = useNavigate();

  const handleImpersonation = async () => {
    if (disabled || loading) return;
    const startedAt = Date.now();

    try {
      const result = await impersonateUser(userId, companyId);

      if (result.success && result.ticket) {
        await waitForImpersonationExitMin(startedAt);
        openImpersonationLanding(buildImpersonationLandingUrl({
          origin: getMainAppOrigin(),
          ticket: result.ticket,
          userId,
          companyId,
          target: result.target,
        }), navigate);
        return;
      }

      showToast(error || 'Failed to impersonate user. Please try again.', 'error');
    } catch (err) {
      console.error('Impersonation error:', err);
      showToast(err?.message || error || 'Failed to impersonate user. Please try again.', 'error');
    }
  };

  return (
    <button
      type="button"
      className={`impersonate-button${fullWidth ? ' impersonate-button--full' : ''}`}
      onClick={handleImpersonation}
      disabled={disabled || loading}
    >
      {loading ? 'Signing in…' : 'Impersonate'}
    </button>
  );
};

export default ImpersonateButton;
